<template>
  <div>
    <Loader v-if="isLoading"></Loader>
    <div v-else-if="caseTypes.length === 0">
      {{ $t('views.excmtask.list.NoTask') }}
    </div>
    <template v-for="(caseType, caseTypeIndex) in caseTypes">
      <div v-if="caseType" :key="'caseType'+caseTypeIndex">
      <h6>{{caseType.title}}</h6>
      <template  v-for="(item, index) in caseType.taskTypes" >
        <table v-if="item && item.tasks.length > 0" :key="item.idTaskType" class="table table-sm table-grid table-responsive-md">
          <tbody class="hover-row">
          <tr @click="expand(caseTypeIndex, index)">
            <td>
              {{ item.title }} ({{ item.tasks.length }})
            </td>
          </tr>
          <tr>
            <td>
              <b-collapse :id="'order_positions_collapse_'+index" v-model="item.expanded">
                <TasksTable :items="item.tasks"
                            :withCheckbox="true"
                            :display-assigned="displayAssigned"
                            :toggle-create-task-modal="toggleCreateTaskModal"
                            :get-data="getData"
                            @selectedCase="updateSelectedCase($event)"/>
              </b-collapse>
            </td>
          </tr>
          </tbody>
        </table>
      </template>
      </div>
    </template>
    <b-dropdown :disabled="$store.state.checkboxes.selectedTasks.length === 0" v-if="!displayAssigned" size="sm" variant="warning" dropright text="Drop-Right">
      <template #button-content>
        {{ $t('buttons.collectionOperations') }}
      </template>
      <b-dropdown-item @click="takeMultipleTasks()"><i class="fa fa-file-check mr-2"></i>{{$t('views.excmtask.list.takeMultipleTasks')}}</b-dropdown-item>
    </b-dropdown>
    <create-task-modal @modalHidden="clearSelectedCase()" v-if="selectedCase" :id-case="selectedCase"></create-task-modal>
    <UpdateTaskParamsModal @reload="getData()"></UpdateTaskParamsModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import addParamsToQuery from '@/utils/addParamsToQuery'
import CreateTaskModal from '@/components/Dashboard/Views/excmtask/modals/CreateTaskModal'
import ApiService from '@/utils/ApiService'
import TasksTable from '@/components/Dashboard/Views/excmtask/components/TasksTable'
import UpdateTaskParamsModal from '@/components/Dashboard/Views/excmtask/modals/UpdateTaskParamsModal'
import Loader from '@/components/Dashboard/Layout/Loader'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'CollapseTaskByTaskType',
  components: {
    Loader,
    UpdateTaskParamsModal,
    TasksTable,
    CreateTaskModal
  },

  props: {
    displayAssigned: {
      type: Boolean,
      default () {
        return true
      }
    },
    searchParams: Object
  },

  data () {
    return {
      selectedCase: '',
      taskTypes: [],
      caseTypes: [],
      isLoading: true
    }
  },
  computed: {
    dispatched: function () {
      return this.$store.state.modals.excmtask.dispatch.dispatched
    },
    ...mapGetters({
      view: 'excmtask/list/view',
      isCreateTaskModalVisible: 'excmtask/createModal/isVisible',
      createdTask: 'excmtask/create/created'
    })
  },
  watch: {
    isCreateTaskModalVisible (val) {
      if (!val && this.createdTask) {
        this.getData()
        this.resetCreatedTask()
      }
    },
    dispatched: function (val) {
      if (val === 1) {
        this.getData()
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    updateSelectedCase (idCase) {
      this.selectedCase = idCase
    },
    async getData () {
      this.taskTypes = []
      this.caseTypes = []
      this.isLoading = true
      let url = addParamsToQuery('e_x_c_m_tasks', this.searchParams)
      let params = { pagination: false }
      const response = await new ApiService(url, params).getResults()
      let tasks = await response.items
      tasks.forEach(entry => {
        if (this.caseTypes[getId(entry.idCase.caseType['@id'])]) {
          if (this.caseTypes[getId(entry.idCase.caseType['@id'])].taskTypes[entry.idTaskType.id]) {
            this.caseTypes[getId(entry.idCase.caseType['@id'])].taskTypes[entry.idTaskType.id].tasks.push(entry)
          } else {
            this.caseTypes[getId(entry.idCase.caseType['@id'])].taskTypes[entry.idTaskType.id] = {
              title: entry.idTaskType.title,
              tasks: [entry]
            }
          }
        } else {
          this.caseTypes[getId(entry.idCase.caseType['@id'])] = {
            title: entry.idCase.caseType.title,
            taskTypes: []
          }
          this.caseTypes[getId(entry.idCase.caseType['@id'])].taskTypes[entry.idTaskType.id] = {
            title: entry.idTaskType.title,
            tasks: [entry]
          }
        }
      })
      this.isLoading = false
    },
    expand (caseTypeIndex, taskIndex) {
      this.caseTypes.forEach((caseType, cIndex) => {
        if (caseType.taskTypes) {
          caseType.taskTypes.forEach((taskType, tIndex) => {
            if (cIndex !== caseTypeIndex || tIndex !== taskIndex) {
              taskType.expanded = false
            }
          })
        }
      })
      this.caseTypes[caseTypeIndex].taskTypes[taskIndex].expanded = !this.caseTypes[caseTypeIndex].taskTypes[taskIndex].expanded
      this.$forceUpdate()
    },
    async takeMultipleTasks () {
      let params = {
        tasks: this.$store.state.checkboxes.selectedTasks
      }
      const response = await new ApiService(`e_x_c_m_tasks/take_tasks_multi`).post(params)
      if (response.status === 200 || response.status === 202 || response.status === 207) {
        this.$store.state.checkboxes.selectedTasks = []
        this.getData()
      }
    },
    clearSelectedCase () {
      this.selectedCase = ''
    },
    ...mapActions({
      getPage: 'excmtask/list/getItems',
      resetCreatedTask: 'excmtask/create/reset'
    }),
    ...mapMutations({
      toggleCreateTaskModal: 'excmtask/createModal/toggleModal'
    })
  }
}
</script>
